module.exports = __webpack_public_path__ + "img/aruba.f951e71.webp";